export default __webpack_public_path__ + "static/media/childcare.5e54ee44.svg";